import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountDeduplicationComponent } from './components/pages/account-deduplication/account-deduplication.component';
import { ConsentPreviewComponent } from './components/pages/consent-preview/consent-preview.component';
import { ConsentScopesComponent } from './components/pages/consent-scopes/consent-scopes.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ForgotPasswordInitComponent } from './components/pages/forgot-password-init/forgot-password-init.component';
import { LoginSuccessComponent } from './components/pages/login-success/login-success.component';
import { LoginComponent } from './components/pages/login/login.component';
import { LogoutSuccessComponent } from './components/pages/logout-success/logout-success.component';
import { MfaRequiredComponent } from './components/pages/mfa-required/mfa-required.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { PasswSetSuccessComponent } from './components/pages/passw-set-success/passw-set-success.component';
import { PasswordSetComponent } from './components/pages/password-set/password-set.component';
import { RegisterSuccessComponent } from './components/pages/register-success/register-success.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { VerificationCompleteComponent } from './components/pages/verification-complete/verification-complete.component';
import { VerificationInitComponent } from './components/pages/verification-init/verification-init.component';
import { AuthenticateComponent } from './components/util/login/authenticate/authenticate.component';
import { InitiateAuthenticationComponent } from './components/util/login/initiate-authentication/initiate-authentication.component';
import { InitiateLoginComponent } from './components/util/login/initiate-login/initiate-login.component';
import { RegisterAdditionalInfoComponent } from './components/pages/register-additional-info/register-additional-info.component';
import { DeviceInitCodeComponent } from './components/util/device-code-flow/device-init-code/device-init-code.component';
import { DeviceSuccessPageComponent } from './components/util/device-code-flow/device-success-page/device-success-page.component';

import { EnableRegisterGuard } from './enable-register.guard';
import { HandleErrorComponent } from './components/util/error/handle-error/handle-error.component';
import { StatusComponent } from './components/pages/status/status.component';
import { GroupSelectionComponent } from './components/pages/group-selection/group-selection.component';
import { ProvidersListComponent } from './components/util/login/providers-list/providers-list.component';
import { SuggestVerificationMethodComponent } from './components/pages/suggest-verification-method/suggest-verification-method.component';
import { ProviderHintGuard } from './provider-hint.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    children: [
      { path: '', component: InitiateLoginComponent },
      { path: 'initiate', component: InitiateAuthenticationComponent },
      { path: 'authenticate', component: AuthenticateComponent },
    ],
    canActivate: [ProviderHintGuard]
  },
  { path: 'device_init_code', component: DeviceInitCodeComponent },
  { path: 'device_success_page', component: DeviceSuccessPageComponent },
  { path: 'register', component: RegisterComponent, canActivate: [EnableRegisterGuard] },
  { path: 'provider_list', component: ProvidersListComponent},
  { path: 'mfa_required', component: MfaRequiredComponent },
  { path: 'consent_preview', component: ConsentPreviewComponent },
  { path: 'password_forgot_init', component: ForgotPasswordInitComponent },
  { path: 'consent_scopes', component: ConsentScopesComponent },
  { path: 'account_deduplication', component: AccountDeduplicationComponent },
  { path: 'register_success', component: RegisterSuccessComponent },
  { path: 'login_success', component: LoginSuccessComponent },
  { path: 'password_set_success', component: PasswSetSuccessComponent },
  { path: 'logout_success', component: LogoutSuccessComponent },
  { path: 'verification_init', component: VerificationInitComponent },
  { path: 'verification_complete', component: VerificationCompleteComponent },
  { path: 'register_additional_info', component: RegisterAdditionalInfoComponent },
  { path: 'password_set', component: PasswordSetComponent },
  { path: 'groupselection', component: GroupSelectionComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'status/:status_type', component: StatusComponent },
  // { path: 'suggest_verification_methods', loadChildren: () => import('./feature/verification/verification.module').then(m => m.VerificationModule), resolve:{currentLang: LanguageResolver}},
  { path: 'suggest_verification_methods', component:SuggestVerificationMethodComponent},
  { path: 'handle_error', component: HandleErrorComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
